// extracted by mini-css-extract-plugin
export default {"subNavGuides":"SubNavGuides__subNavGuides__UZpWT"};